import { render, staticRenderFns } from "./DefaultPolicyTransactionsList.vue?vue&type=template&id=60e4f3f2"
import script from "./DefaultPolicyTransactionsList.vue?vue&type=script&lang=js"
export * from "./DefaultPolicyTransactionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports